module.exports = __webpack_public_path__ + "static/Wisdo-e7525e07bab4394068e496e46c4630c9.jpg";